import emptyDashboardImageUrl from "@/assets/empty-dashboard.svg"

type EmptyDashboardProps = {
  message?: string
  onRetry?: () => void
}

const EmptyDashboard = ({ message, onRetry }: EmptyDashboardProps) => {
  if (message) {
    return (
      <div className="flex flex-col items-center gap-4 py-12 text-center">
        <p className="text-primary-contrast/60">{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="rounded-md bg-secondary px-4 py-2 text-sm font-medium text-primary-contrast/80 hover:bg-secondary"
          >
            Try again
          </button>
        )}
      </div>
    )
  }

  return (
    <div className="mt-8 flex flex-col gap-8">
      <img
        alt="empty-screen"
        src={emptyDashboardImageUrl}
        className="w-full"
      />
      <div className="flex flex-col gap-[14px] text-center">
        <h2 className="text-h2">Ready to test out your blood glucose monitor?</h2>
        <h2 className="text-h2">Go ahead and take a measurement</h2>
      </div>
    </div>
  )
}

export default EmptyDashboard
